// extracted by mini-css-extract-plugin
export default {"container":"WindowLayout_container__i2A2U","title":"WindowLayout_title__D+kwA","content":"WindowLayout_content__wxUDK"};